import { defineEvent } from '../types/event';
export var PRODUCT_DETAILS_CLICK = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'Clicks_on_Product_Details'
        }
    ]
});
